import React, { useState } from "react";
import Calendar, { CalendarTileProperties, DateCallback } from "react-calendar";
import { isSameDay, add, isToday, format } from "date-fns";
import SessionPopover from "./SessionPopover";
import { Session, Callback } from "types";
import { useQuery } from "@tanstack/react-query";
//import { queryKeys, queryFns } from "repo/sessions";
import { FetchDataProps, LazyData, LazyFilters } from "types/datacontext";
import * as API from "api/webservice/sessions";

const MiniCalendar: React.FC = () => {
  interface FetchDataOptions {
    owned?: boolean
  }

  //refactor later for clarity
  const startDate = new Date();
  startDate.setMonth(startDate.getMonth());
  startDate.setDate(1);
  startDate.setHours(0);
  startDate.setMinutes(0);
  startDate.setSeconds(0);
  startDate.setMilliseconds(0);

  const endDate = new Date();
  endDate.setMonth(endDate.getMonth() + 1);
  endDate.setDate(0);
  endDate.setHours(23);
  endDate.setMinutes(59);
  endDate.setSeconds(59);
  endDate.setMilliseconds(999);

  const [calendarDateRange, setCalendarDateRange] = useState<Date[]>([startDate, endDate]);

  const { isLoading, data, error } = useQuery({
    queryKey: ['sessions', 'calendar',  calendarDateRange],
    queryFn: ({ queryKey }) => {
      const [,,dateRange] = queryKey;
      const [start_time_range, end_time_range] = dateRange;
      return API.fetchCalendar(start_time_range, end_time_range);
    },
  });

  const [value, setValue] = useState(new Date());

  const tileContent = ({ date, view }: CalendarTileProperties) => {
    // const classes: string[] = [];
    if (view === "month" && !isLoading && data) {
      // if (isToday(date)) { classes.push('today'); }
      const session: Session | undefined = data.find(session =>
        isSameDay(new Date(session.start_time), date)
      );
      return !!session ? <SessionPopover {...session} /> : null;
    }
    return null;
  };

  const tileClassName = ({ date, view }: CalendarTileProperties) => {
    const classes: string[] = [];
    if (view === "month" && !isLoading) {
      if (isToday(date)) {
        classes.push("today");
      }
      if (data && data.find(session => isSameDay(new Date(session.start_time), date))) {
        classes.push("day-with-session");
      }
    }
    return classes;
  };

  const createDateRange = (date: Date) => {
    const endDate = new Date(date.valueOf());
    endDate.setMonth(date.getMonth()+1);
    endDate.setDate(0);
    endDate.setHours(23);
    endDate.setMinutes(59);
    endDate.setSeconds(59);
    endDate.setMilliseconds(999);
    setCalendarDateRange([date, endDate]);
  }

  return (
    <Calendar
      value={value}
      tileContent={tileContent}
      tileClassName={tileClassName}
      className="dashboard-mini-calendar"
      formatShortWeekday={(locale, date) => format(date, "EEEEE")}
      formatMonthYear={(locale, date) =>
        format(date, "MMM yyyy").toLocaleUpperCase()
      }
      formatMonth={(locale, date) => format(date, "MMM").toLocaleUpperCase()}
      minDetail="month"
      prev2Label={null}
      next2Label={null}
      showNeighboringMonth={false}
      onActiveStartDateChange={({ action, activeStartDate, value, view }) => createDateRange(activeStartDate)}
    />
  );
};

export default MiniCalendar;
